import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import SymptomCheckService from '../../services/symptom-check.service';
import FetchingService from '../../services/fetching.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'symptom-check-factors',
	templateUrl: './symptom-check-factors.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class SymptomCheckFactorsComponent implements OnInit, OnDestroy {
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private fetchingService: FetchingService = inject(FetchingService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() interview: any;
	@Output() interviewChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor(private cdr: ChangeDetectorRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.preFillEnum = 'RISK_FACTORS_PRE_FILL';
		this.fetchingService.clear(this.vm.preFillEnum);
		this.vm.groupChoiceOptions = this.symptomCheckService.getGroupChoiceOptions();
		this.vm.groupChoiceIds = Object.keys(this.vm.groupChoiceOptions);
		
		var evidence: any = {};
		if (this.vm.interview.evidence) {
			this.vm.interview.evidence.forEach(function(item) {
				if (item.addedAtStep === 3) {
					evidence[item.id] = item.choice_id;
				}
			});
		}
		this.vm.evidence = evidence;
		
		var options: any = { threshold: 300 };
		if (this.vm.interview.age !== undefined) {
			options.params = { age: this.vm.interview.age };
		}
		
		this.fetchingService.get(this.vm.interview.age !== undefined && this.vm.interview.age < 16 ? 'RISK_FACTORS_MINORS' : 'RISK_FACTORS', options)
			.then((response) => {
				var factors: any = response || [];
				var genericFactors: any = factors.filter(function(factor) { return factor.generic; });
				genericFactors.forEach((factor) => {
					if (!this.vm.evidence[factor.riskFactor.id]) {
						this.vm.evidence[factor.riskFactor.id] = null;
					}
				});

				this.vm.factors = genericFactors;
				this.vm.isInitialized = true;
				this.fetchingService.get(this.vm.preFillEnum)
					.then((response) => {
						response.forEach((evidencePreFill) => {
							Object.keys(this.vm.evidence).forEach((evidence) => {
								if (evidencePreFill.id === evidence) {
									this.vm.evidence[evidence] = evidencePreFill.choice_id;
									return;
								}
							})
						});
					});
			})
			.catch(console.error);
		
		var currentEvidence = {};
		this.watcher = this.angularHelperService.createInterval(() => {
			var newEvidence = this.vm.evidence;
			if (!this.angularHelperService.isEqual(currentEvidence, newEvidence)) {
				this.handleEvidenceUpdate(newEvidence, currentEvidence);
				currentEvidence = Object.assign({}, newEvidence);
			}
		}, 300);
		
		this.vm.handleBack = this.symptomCheckService.prevStep;
		this.vm.handleSubmit = this.handleSubmit;
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}
	
	handleEvidenceUpdate(nv, ov) {
		if (this.angularHelperService.equals(nv, ov)) return;
		
		this.updateEvidence();
	}
	
	updateEvidence() {
		var interview: any = this.symptomCheckService.getInterviewResetTo(3);
		interview.evidence = Object.keys(this.vm.evidence).map((evidenceId) => {
			return {
				id: evidenceId,
				choice_id: this.vm.evidence[evidenceId],
				addedAtStep: 3,
				source: 'predefined'
			};
		});

		this.vm.interview = interview;
		this.interviewChange.emit(this.vm.interview);
	}
	
	handleSubmit() {
		this.vm.submitted = true;
		this.updateInvalids();
		if (this.vm.invalid) {
			return;
		}

		this.updateEvidence();
		
		this.symptomCheckService.nextStep();
	}
	
	updateInvalids(riskFactorId?) {
		if (this.vm.submitted) {
			this.vm.invalids = {};
			var invalid = false;
			for (var i = 0; i < this.vm.factors.length; i++) {
				var factor = this.vm.factors[i];
				if (!this.vm.evidence[factor.riskFactor.id] && riskFactorId !== factor.riskFactor.id) {
					this.vm.invalids[factor.riskFactor.id] = true;
					invalid = true;
				}
			}
			this.vm.invalid = invalid;
		}
		if (riskFactorId) {
			this.cdr.detectChanges();
		}
	}
	
}